export default () => ({
  productsTotal: 0,
  products: {},
  syncing: false,
});
